import { defineRecipe } from "@chakra-ui/react";

const flexRecipe = defineRecipe({
    base: {
        focusRing: "none"
    },
    variants: {
        focusRing: {
            none: {
                focusRing: "none"
            }
        }
    }
});
export default flexRecipe;
